import type { SearchResponse, SearchResult } from '@munifocus/contracts-gov';
import { api } from './api-client';

/**
 * Global search behind the command palette.
 *
 * Takes the palette's `AbortSignal` so a superseded keystroke's request is
 * cancelled in flight rather than raced to completion — without it a slow early
 * request can resolve after a faster later one and repaint stale results.
 */
export async function globalSearch(query: string, signal: AbortSignal): Promise<SearchResult[]> {
  const { data } = await api.get<SearchResponse>('/search', { params: { q: query }, signal });
  return data.results;
}
